/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTranslation } from 'react-i18next'
import { Dispatch, SetStateAction, useState } from 'react'
import MobileIconButton from '@/features/mobile-app/components/MobileIconButton/MobileIconButton'
import useMobileAppManagementQuery from '@/features/mobile-app/hooks/useMobileAppManagementQuery'
import { useMenuTypesQuery } from '@/features/menu-management/SidebarAccordion/hooks/useMenuTypesQuery'
import sausageAndOlivesPizza from '@assets/images/sausageAndOlivesPizza.jpg'
import smokyChickenPizza from '@assets/images/smokyChickenPizza.jpg'
import bbqChickenBroccoliPizza from '@assets/images/bbqChickenBroccoliPizza.jpg'
import vegetarianPizza from '@assets/images/vegetarianPizza.jpg'
import chickenAndOnionPizza from '@assets/images/chickenOnionPizza.jpg'
import NavigationHeader, {
  NavigationHeaderModule
} from '@/features/mobile-app/components/NavigationHeader/NavigationHeader'
import styles from './Menu.module.scss'
import MenuItemTile from '@/features/mobile-app/components/MenuItemTile/MenuItemTile'
import { useDishCategoriesQuery } from '@/features/menu-management/SidebarAccordion/hooks/useDishCategoriesQuery'
import IconButton from '@/shared/components/IconButton/IconButton'

interface MenuProps {
  setIsMenuCardOpen: Dispatch<SetStateAction<boolean>>
}

interface MenuItem {
  name: string
  description: string
  price: string
  dishImage?: string
}

function Menu({ setIsMenuCardOpen }: MenuProps) {
  const { t } = useTranslation()

  const { menuTypesList } = useMenuTypesQuery()
  const { dishCategoriesList } = useDishCategoriesQuery()
  const [, setSelectedMenuTypeId] = useState<string | null>(
    menuTypesList?.data?.[0]?.id || null
  )
  useMobileAppManagementQuery()

  const navigationHeaders: NavigationHeaderModule[] =
    dishCategoriesList?.data?.map((menuType, index) => ({
      label: menuType.translations[0]?.name || `Menu Type ${index + 1}`,
      action: () => setSelectedMenuTypeId(menuType.id || null)
    })) || []

  const menuItems = [
    {
      name: 'Smoky Chicken & Peppers',
      description:
        'Grilled chicken, mushrooms, and sweet peppers on melted mozzarella.',
      price: '$5.00',
      dishImage: smokyChickenPizza
    },
    {
      name: 'Sausage & Olive Classic',
      description:
        'Italian sausage and mixed olives over rich tomato sauce and mozzarella.',
      price: '$6.00',
      dishImage: sausageAndOlivesPizza
    },
    {
      name: 'BBQ Chicken & Broccoli',
      description: 'BBQ chicken and fresh broccoli on a cheesy, tangy base.',
      price: '$6.00',
      dishImage: bbqChickenBroccoliPizza
    },
    {
      name: 'Vegetarian Pizza',
      description:
        'Classic pizza topped with black olives, green peppers, and generous amounts of melted cheese.',
      price: '$5.50',
      dishImage: vegetarianPizza
    },
    {
      name: 'Chicken & Onion Pizza',
      description:
        'A delicious combination of tender chicken pieces and sliced red onions on a crispy base.',
      price: '$6.00',
      dishImage: chickenAndOnionPizza
    }
  ] as MenuItem[]

  return (
    <div className={styles.menuWrapper}>
      <div className={styles.menuHeaderContainer}>
        <div className={styles.menuHeader}>
          <MobileIconButton
            iconName="las la-angle-left icon-big"
            onClick={() => setIsMenuCardOpen(false)}
            colorType="primary"
            variant="text"
          />
          <p className={`body-bold-large ${styles.menuTitle}`}>
            {t('MOBILE_APP.MENU.TITLE')}
          </p>
          {/* <div className={styles.menuHeaderPlaceholder} /> */}
          <IconButton
            icon="las la-sliders-h icon-big"
            color="primary"
            onClick={() => null}
          />
        </div>
        <div className={styles.menuNavigationContainer}>
          <NavigationHeader navigationHeaders={navigationHeaders} />
        </div>
      </div>
      <div className={styles.menuContent}>
        {menuItems.map(menuItem => (
          <MenuItemTile
            name={menuItem.name}
            description={menuItem.description}
            price={menuItem.price}
            dishImage={menuItem.dishImage}
          />
        ))}
      </div>
    </div>
  )
}

export default Menu
